module.exports = __webpack_public_path__ + "static/media/play.1fb00f24.svg";